import axios, { AxiosRequestConfig } from 'axios';

import { apiRequest, apiRequests } from 'helpers';
import {
  EmployerFullCandidateProps,
  ReviewedCandidateProps,
  ReviewedFullCandidateProps,
  Flag,
  CandidateApplication,
} from 'types';

export const patchCandidateReviewStatus = (
  candidate_id: number,
  config: AxiosRequestConfig,
) =>
  apiRequest<CandidateApplication>({
    method: 'PATCH',
    path: `/v3/candidates/${candidate_id}/review_status`,
    ...config,
  });

export const fetchCandidatesWithReviewStatus = (config: AxiosRequestConfig) =>
  apiRequest<Array<CandidateApplication>>({
    method: 'GET',
    path: '/v3/candidates/review_status',
    ...config,
  });

export const fetchCandidates = (config: AxiosRequestConfig) =>
  apiRequest<Array<ReviewedCandidateProps>>({
    method: 'GET',
    path: '/v3/candidates',
    ...config,
  });

export const fetchOrganizationCandidateTemplate = (organization_id: number) => {
  return apiRequest<Blob>({
    method: 'GET',
    path: '/v3/candidates',
    params: {
      organization_id: organization_id,
      as_csv: true,
      limit: 0,
      csv_headers: [
        'id',
        'case_number',
        'passport_number',
        'tazkera',
        'firstname',
        'lastname',
        'birthdate',
      ],
    },
    headers: {
      Accept: 'text/csv',
      'Content-Type': 'text/csv',
    },
    responseType: 'blob',
  });
};

export const fetchVerboseCandidates = (config: AxiosRequestConfig) =>
  apiRequest<Array<ReviewedFullCandidateProps>>({
    method: 'GET',
    path: '/v3/candidates/verbose',
    ...config,
  });

export const fetchCandidate = (candidate_id: number) =>
  apiRequest<ReviewedFullCandidateProps>({
    method: 'GET',
    path: `/v3/candidates/${candidate_id}`,
  });

export const fetchCandidateWithStatus = (candidate_id: number) =>
  apiRequests<EmployerFullCandidateProps>([
    {
      method: 'GET',
      path: `/v3/candidates/${candidate_id}`,
    },
    {
      method: 'GET',
      path: `/v3/candidates/review_status?candidate_id=${candidate_id}`,
    },
  ]).then(
    axios.spread((candidate_response: any, candidate_status_response: any) => {
      const candidate = candidate_response.data;
      const candidate_status = candidate_status_response.data.find(
        (candidate: CandidateApplication) =>
          candidate.candidate_id === candidate_id,
      );
      return {
        ...candidate,
        review_status: candidate_status.review_status,
        review_status_comment: candidate_status.review_status_comment,
      };
    }),
  );

export const patchCandidateStatus = (props: {
  candidate_id: number;
  data: Partial<CandidateApplication>;
}) => {
  const { candidate_id, data } = props;
  return apiRequest<CandidateApplication>({
    method: 'PATCH',
    path: `/v3/candidates/${candidate_id}/review_status`,
    data: data,
  });
};

// 409: "Candidate with that SIV# already exists."
export const patchCandidate = (
  candidate_id: number,
  config: AxiosRequestConfig,
) =>
  apiRequest<ReviewedCandidateProps>({
    method: 'PATCH',
    path: `/v3/candidates/${candidate_id}`,
    ...config,
  });

export const batchCreateFlags = (candidate_ids: Array<number>, flag: Flag) =>
  apiRequest<Array<ReviewedFullCandidateProps>>({
    method: 'POST',
    path: '/v3/candidates/flags',
    data: {
      candidate_ids,
      flag,
    },
  });
